<template>
  <v-container fluid>
    <v-layout column>
      <v-layout row wrap v-if="$slots.backbtn" class="pl-panel pl-block pl__linkRow justify-space-between align-center">
        <slot name="backbtn" />
        <slot name="help" />
      </v-layout>

      <v-layout row wrap v-if="$slots.panel" class="pl-panel pl-block">
        <slot name="panel" />
      </v-layout>

      <v-layout row wrap v-if="$slots.counter" class="pl-services-table__row_name">
        <slot name="counter" />
      </v-layout>

      <div class="pl-block">
        <slot />
      </div>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Table',
}
</script>
